import React from 'react';
import './Home_dec.css';

// Type definition for component props
interface HomeProps {
  onNavigateToHighlights: () => void;
}

// Type definitions for board member data
interface BoardMember {
  id: string;
  name: string;
  position: string;
  major: string;
  imageUrl: string;
  altText: string;
  className: string;
}

const Home: React.FC<HomeProps> = ({ onNavigateToHighlights }) => {

  // Board members data with proper typing - Updated with real ADG members
  const boardMembers: BoardMember[] = [
    {
      id: "andile",
      name: "Andile Khumalo",
      position: "Co-President",
      major: "Mathematics/Statistics '26",
      imageUrl: "/Andile photo2.jpg",
      altText: "Andile Khumalo",
      className: "adg1 board"
    },
    {
      id: "colin",
      name: "Colin J. Emmanuel",
      position: "Co-President",
      major: "Computer Science '26",
      imageUrl: "/Colin J. Emmanuel.jpg",
      altText: "Colin J. Emmanuel",
      className: "adg2 board"
    },
    {
      id: "eunice",
      name: "Eunice Akoth",
      position: "Vice President",
      major: "Political Science/Human Rights '26",
      imageUrl: "/Eunice Akoth photo.jpg",
      altText: "Eunice Akoth",
      className: "adg3 board"
    },
    {
      id: "fatoumata_n",
      name: "Fatoumata Niangadou",
      position: "Research Chair",
      major: "Economics '27",
      imageUrl: "/Fatoumata Niangadou Photo.jpg",
      altText: "Fatoumata Niangadou",
      className: "adg4 board"
    },
    {
      id: "rokhiyatou",
      name: "Rokhiyatou Diawara",
      position: "Research Chair",
      major: "Sociology '27",
      imageUrl: "/Rokhiyatou Diawara Photo.jpg",
      altText: "Rokhiyatou Diawara",
      className: "adg5 board"
    },
    {
      id: "ebebe",
      name: "Ebebe Lionel",
      position: "Secretary",
      major: "Computer Science '27",
      imageUrl: "/Ebebe Lionel photo.jpg",
      altText: "Ebebe Lionel",
      className: "adg6 board"
    },
    {
      id: "fatoumata_g",
      name: "Fatoumata Gakou",
      position: "Research and Forum Chair",
      major: "Psychology/Africana Studies '27",
      imageUrl: "/Fatoumata Gakou.jpg",
      altText: "Fatoumata Gakou",
      className: "adg7 board"
    },
    {
      id: "anjelica",
      name: "Anjelica Young",
      position: "Treasurer",
      major: "Neuroscience '28",
      imageUrl: "/Anjelica Young photo.jpg",
      altText: "Anjelica Young",
      className: "adg8 board"
    },
    {
      id: "victoria",
      name: "Victoria Afolabi",
      position: "Public Relations Chair",
      major: "Economics/Political Science '27",
      imageUrl: "/Victoria Afolabi photo.jpg",
      altText: "Victoria Afolabi",
      className: "adg9 board"
    }
  ];

  // Smooth scroll function
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 85; // Account for sticky header height
      const elementPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  // Navigation to Highlights page
  const navigateToHighlights = () => {
    onNavigateToHighlights();
  };


  // African continent SVG icon component
  const AfricaIcon: React.FC = () => (
    <svg className="africa-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path d="M50 10 
               C52 12, 55 15, 58 18
               C60 22, 62 25, 65 30
               C67 35, 68 40, 70 45
               C72 50, 73 55, 74 60
               C75 65, 74 70, 72 75
               C70 80, 68 83, 65 85
               C60 87, 55 88, 50 89
               C45 88, 40 87, 35 85
               C32 83, 30 80, 28 75
               C26 70, 25 65, 26 60
               C27 55, 28 50, 30 45
               C32 40, 33 35, 35 30
               C38 25, 40 22, 42 18
               C45 15, 48 12, 50 10 Z
               
               M45 25
               C43 27, 42 30, 40 32
               C38 35, 36 38, 35 42
               C34 45, 35 48, 37 50
               C39 52, 42 53, 45 52
               C48 51, 50 49, 52 47
               C54 45, 55 42, 56 39
               C57 36, 56 33, 54 31
               C52 29, 49 28, 46 27
               C45.5 26, 45 25.5, 45 25 Z" />
    </svg>
  );
  
  const BoardMemberCard: React.FC<{ member: BoardMember }> = ({ member }) => (
    <div className={member.className}>
      <img 
        id={member.id}
        src={member.imageUrl}
        alt={member.altText}
      />
      <h3>{member.name}</h3>
      <h4>{member.position}</h4>
      <h5>{member.major}</h5>
    </div>
  );

  return (
    <>
      <div className="head_shad">
        <header>
          <div className="header-content">
            <div className="logo-section">
              <h1>ADG</h1>
              <img 
                src="https://cdn-icons-png.flaticon.com/128/15967/15967383.png" 
                alt="Africa Continent" 
                className="africa-icon"
              />
            </div>
            <nav className="nav-links">
              <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
              <button onClick={() => scrollToSection('mission')} className="nav-link">Mission</button>
              <button onClick={() => scrollToSection('eboard')} className="nav-link">E-Board</button>
              <button onClick={navigateToHighlights} className="nav-link">Highlights</button>
              <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
            </nav>
          </div>
        </header>
      </div>
      
      <section className="intro-pic">
        <img
          id="adg-pic"
          src="./Yaounde.png"
          alt="adg_img"
        />
        <div className="title-block">
          <h2>African Development Group</h2>
        </div>
      </section>
      
      <div className="sections" id="about">
        <h2>About Us</h2>
        <p className="notes">
          ADG is a dynamic group of passionate youths dedicated to educating people and creating awareness 
          about the various ways we can adopt to better the African continent. Founded in 2016, we believe 
          that meaningful change begins with education and informed action. Our organization serves as a 
          platform for young voices committed to addressing the political and socioeconomic challenges 
          facing Africa today. Through engaging discussions, educational initiatives, and community outreach, 
          we work to empower individuals with the knowledge and tools necessary to contribute to positive 
          transformation across the continent. We are not afraid to call out corruption and advocate for 
          transparency, accountability, and good governance in all sectors of society.
        </p>
      </div>
      
      <div className="sections" id="mission">
        <h2>Our Mission</h2>
        <p className="notes">
          To empower and educate young people about Africa's potential while fostering critical thinking 
          and active citizenship. We strive to create a generation of informed leaders who are equipped 
          with the knowledge, passion, and determination to drive sustainable development across the 
          African continent. Through educational programs, awareness campaigns, and advocacy initiatives, 
          we aim to bridge the gap between knowledge and action, inspiring youth to become catalysts 
          for positive change in their communities and beyond. Our mission is to cultivate a culture 
          of transparency, accountability, and ethical leadership that will shape Africa's future.
        </p>
      </div>
      
      <div className="sections">
        <h2>Location and Time</h2>
        <p className="notes">
          8:30pm at Hamilton 702 biweekly unless announced otherwise on{' '}
          <a href="https://docs.google.com/spreadsheets/d/1V9eD_ip3CJ6H9-0vQzViVJZkFuhECOS4VWXf3ZkYNP8/edit?usp=sharing">mailing list</a> or social media post
        </p>
      </div>
      
      <div className="e_board" id="eboard">
        <h1>E-Board</h1>
        <div className="container">
          {boardMembers.map((member: BoardMember) => (
            <BoardMemberCard key={member.id} member={member} />
          ))}
        </div>
      </div>
      
      <div className="sections" id="contact">
        <h2>Book A Presentation</h2>
        <p className="notes">
          To book a presentation, contact the club at adg@columbia.edu 
          providing a suitable date and time
        </p>
      </div>
    </>
  );
};

export default Home;